import { Pagination } from "../../../../components/ui/Table/Pagination/Pagination";
import Modal from "../../../../components/ui/Modal/Modal";
import { SaveIcon } from "../../../../assets/icons";
import {
  convertDateToDateTime,
  convertSecondsToDate,
  convertSecondsToDateTime,
} from "../../../../helper/formatDate/formate-date";
import QRDetail from "./QRDetail";
import QRForm from "./QRForm";
import dayjs from "dayjs";

const table = {
  header: [
    {
      id: 1,
      title: "번호",
    },
    {
      id: 2,
      title: "구분",
    },
    {
      id: 3,
      title: "상품명",
    },
    {
      id: 4,
      title: "REF(상품코드)",
    },
    {
      id: 5,
      title: "LOT",
    },
    {
      id: 6,
      title: "QR번호",
    },
    {
      id: 7,
      title: "제조일자",
    },
    {
      id: 8,
      title: "유효일자",
    },
    {
      id: 9,
      title: "최종 업데이트일",
    },
    {
      id: 10,
      title: "관리",
    },
  ],
};
export default function TableDetailQR({
  productLots,
  product,
  onSubmitProductLot,
  productCodeQR,
  setTriggerCloseModal,
  isEditForm,
  setIsEditForm,
  onEditForm,
  triggerCloseModal,
}) {
  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className={`p-2 ${
                    val?.id === 3 || val?.id === 4
                      ? "bg-[#DAE3F7]"
                      : "bg-[#f2f2f4]"
                  } border border-[#dddddd]`}
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {productLots?.length > 0 ? (
              productLots?.map((val, index) => {
                const indexVal = productLots?.length - index;
                return (
                  <tr key={val?.id}>
                    <td className="p-2 border border-[#dddddd]">{indexVal}</td>
                    <td className="p-2 border border-[#dddddd]">
                      {val?.type === "SMART"
                        ? "스마트팩토리 연동"
                        : "수동 등록"}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {product?.name}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {product?.ref}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {val?.lotNo.length > 10 ? (
                        <div>
                          {val?.lotNo?.substring(0, 10)}
                          <br />
                          {val?.lotNo?.slice(10)}
                        </div>
                      ) : (
                        val?.lotNo
                      )}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {val?.qrNo.length > 16 ? (
                        <div>
                          {val?.qrNo?.substring(0, 16)}
                          <br />
                          {val?.qrNo?.slice(16)}
                        </div>
                      ) : (
                        val?.qrNo
                      )}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {dayjs(val?.manufacDate).format("YYYY-MM-DD")}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {dayjs(val?.expireDate).format("YYYY-MM-DD")}
                    </td>
                    <td className="p-2 border border-[#dddddd]">
                      {dayjs(val?.updatedAt).format("YYYY-MM-DD")}
                    </td>

                    <td className="p-2 border border-[#dddddd]">
                      <Modal
                        padding="p-7"
                        width="w-[50rem]"
                        maxWidth="w-[50rem]"
                        title={
                          val?.type === "SMART"
                            ? "LOT 상세정보 (스마트팩토리 연동)"
                            : "LOT 상세정보 (수동 등록)"
                        }
                        hasCancel={false}
                        hasSubmit={false}
                        onCancel={() => setIsEditForm(false)}
                        closable={false}
                        triggerClose={triggerCloseModal}
                        rightTittle={
                          <Modal
                            description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                            onSubmit={() => setTriggerCloseModal(true)}
                          >
                            <div className="cursor-pointer font-bold text-[14px]">
                              X
                            </div>
                          </Modal>
                        }
                        description={
                          isEditForm ? (
                            <QRForm
                              onSubmit={onSubmitProductLot}
                              product={product}
                              productCodeQR={productCodeQR}
                              defaultValue={val}
                            />
                          ) : (
                            <QRDetail
                              product={product}
                              productCodeQR={val}
                              onEditForm={onEditForm}
                            />
                          )
                        }
                      >
                        <button className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]">
                          상세
                        </button>
                      </Modal>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
                <td className="p-2 border border-[#dddddd] h-[50px]"></td>
              </tr>
            )}
            {/* ))} */}
          </tbody>
        </table>
      </div>
      <div className="mt-6 flex justify-end overflow-auto w-full">
        <Pagination
          total={1}
          page={0}
          isDisabledPrevPage={false}
          isDisabledNextPage={false}
          onPrevClick={() => {}}
          onNextClick={() => {}}
          onChange={() => {}}
        />
        <div className="flex-none">
          <Modal
            hasCancel={false}
            description="다운로드 되었습니다."
            onSubmit={() => {}}
          >
            <button className="p-[5px] px-[10px] border border-[#cccccc] rounded-[4px] text-[#333333]">
              <div className="flex items-center gap-2">
                <SaveIcon />
                엑셀 저장
              </div>
            </button>
          </Modal>
        </div>
      </div>
    </>
  );
}
